import SectionView from '@/components/SectionView';
import prepareTranslate from '@/helpers/dictionary';
import { useEffect } from 'react';
import Modal from '@/components/DetailsModal';
import PropTypes from 'prop-types';
import { formatDateToDDMMYYYY } from '@/helpers/string';
import paymentProofMutations from '@/api/mutitations/paymentProof';
import DownloadFile from '../DownloadFile';

function ViewPaymentProof(props) {
  const {
    open, close, opened, id,
  } = props;
  const t = prepareTranslate();

  const {
    mutate: getPaymentProofById,
    data: paymentProofData,
  } = paymentProofMutations.useGetPaymentProofById();

  useEffect(() => {
    if (opened && id) {
      getPaymentProofById({ data: { id } });
    }
  }, [opened, id, getPaymentProofById]);

  const buildProofLines = (proof) => [
    [
      {
        title: t('components.viewPaymentProof.details.paymentProofNumber'),
        value: proof?.paymentProof?.paymentProofNumber,
      },
      {
        title: t('components.viewPaymentProof.details.paymentDate'),
        value: formatDateToDDMMYYYY(proof?.paymentProof?.paymentDate),
      },
      proof?.paymentProof.value && {
        title: t('components.viewPaymentProof.details.value'),
        value: proof.paymentProof?.value,
      },
      proof?.paymentProof?.comments && {
        title: t('components.viewPaymentProof.details.comments'),
        value: proof.paymentProof?.comments,
      },
    ].filter(Boolean),
    [
      {
        title: t('components.viewPaymentProof.details.associatedAgents'),
        value: proof?.paymentProof?.associatedAgents
          ?.map((agent) => agent.personalDetails?.fullName)
          .join(', '),
        fullWidth: true,
      },
    ].filter(Boolean),
  ].filter((group) => group.length > 0);

  return (
    <Modal
      open={open}
      close={close}
      opened={opened}
      label={t('components.viewPaymentProof.title')}
    >
      <SectionView lines={buildProofLines(paymentProofData)} />
      {paymentProofData?.paymentProof?.files?.map((file, index) => (
        <DownloadFile key={index} file={file} />
      ))}
    </Modal>
  );
}

ViewPaymentProof.propTypes = {
  open: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  opened: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

export default ViewPaymentProof;
